// Iter 66b: selettore lingua IT/EN
import { useTranslation } from "react-i18next";

export const LangSwitch = ({ dark = false }) => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "it").slice(0, 2);
  const base = "px-2.5 py-1 rounded text-[11px] font-mono font-bold transition-colors";
  const activeCls = dark ? "bg-white text-slate-900" : "bg-slate-900 text-white";
  const idleCls = dark ? "text-slate-300 hover:bg-white/10" : "text-slate-500 hover:bg-slate-100";
  return (
    <div
      className={`inline-flex items-center gap-0.5 rounded-md border p-0.5 ${dark ? "border-white/20" : "border-slate-200"}`}
      data-testid="lang-switch"
    >
      {["it", "en"].map((l) => (
        <button
          key={l}
          type="button"
          data-testid={`lang-${l}`}
          onClick={() => i18n.changeLanguage(l)}
          className={`${base} ${lang === l ? activeCls : idleCls}`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
